import { render, staticRenderFns } from "./FeedInSystemsDetailsPage.vue?vue&type=template&id=c1ac1b30"
import script from "./FeedInSystemsDetailsPage.vue?vue&type=script&lang=js"
export * from "./FeedInSystemsDetailsPage.vue?vue&type=script&lang=js"
import style0 from "./FeedInSystemsDetailsPage.vue?vue&type=style&index=0&id=c1ac1b30&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VAlert,VBtn,VIcon,VProgressCircular})
